export default __webpack_public_path__ + "static/media/icon-dashboard.3c22f07f.svg";